function injectStyle (ssrContext) {
  require("!!../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-99c0fdb6\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../vue-loader/lib/selector?type=styles&index=0!./CubeShadow.vue")
}
var Component = require("!../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../vue-loader/lib/selector?type=script&index=0!./CubeShadow.vue"),
  /* template */
  require("!!../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-99c0fdb6\"}!../../../vue-loader/lib/selector?type=template&index=0!./CubeShadow.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-99c0fdb6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-loading-spinner/src/components/CubeShadow.vue
// module id = 641
// module chunks = 0